<template>
  <div>
    <v-simple-table class="ma-4 produtos-table">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left" style="min-width: 400px">Produto</th>
          <th class="text-left" style="min-width: 30px">Quantidade</th>
          <th style="min-width: 60px">Unidade de medida</th>
          <th style="min-width: 200px">Especificação</th>
          <th style="min-width: 138px"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(produto, index) in requisicao.produtos"
            :key="produto.$$id"
            style="height: 60px">
          <px-cadastro-requisicao-produtos-table-item ref="produtos"
                                                      :produto="produto"
                                                      :erp-campos-integracao="erpCamposIntegracao"
                                                      :campos-obrigatorios="camposObrigatorios"
                                                      :requisicao="requisicao"
                                                      @remove-produto="removeProduto(index)"
                                                      @duplicar-produto="duplicar"/>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-btn small color="primary" class="rounded-tag-small normal-btn-text elevation-0"
               @click="adicionarProduto">
          <v-icon small>mdi-plus</v-icon>
          Produto
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             @click="next">
        Continuar
      </v-btn>
      <v-btn text @click="previous" class="normal-btn-text">Voltar</v-btn>
    </div>
  </div>
</template>

<script>
import { cloneDeep, uniqueId } from 'lodash';
import validationMixin from '@/mixins/validation-mixin';
import CadastroRequisicaoProdutosTableItem
  from '@/modules/requisicao/cadastro/CadastroRequisicaoProdutosTableItem.vue';

const initalState = () => ({
  produto: null,
  quantidade: null,
  unidadeMedida: {
    id: null,
    descricao: null,
    codigoInterno: null,
  },
  arquivos: [],
  especificacaoProduto: null,
  observacaoInterna: null,
  observacaoExterna: null,
  projeto: null,
  centroCusto: null,
  cadastrosAdicionais: null,
  $$hasFileLoading: false,
});

export default {
  mixins: [validationMixin],
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
    isEdicao: Boolean,
    camposObrigatorios: Object,
    erpCamposIntegracao: String,
  },
  data() {
    return {
      isCopy: this.$route.params.isCopy,
      isRascunho: this.$route.params.isRascunho,
    };
  },
  methods: {
    isFormValid() {
      return this.$refs.produtos.map(produto => produto.validate())
        .every(validation => validation);
    },
    next() {
      if (!this.isFormValid()) {
        return;
      }
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    },
    idGenerator() {
      return uniqueId();
    },
    duplicar(item) {
      const newProduto = {
        ...item,
        id: undefined,
        $$id: this.idGenerator(),
        quantidade: item.quantidade,
      };
      this.requisicao.produtos.push(cloneDeep(newProduto));
    },
    adicionarProduto() {
      this.requisicao.produtos.push({
        ...initalState(),
        $$id: this.idGenerator(),
        centroCusto: this.requisicao.centroCusto ?? null,
        projeto: this.requisicao.projeto ?? null,
      });
    },
    removeProduto(index) {
      if (this.requisicao.produtos.length <= 1) {
        return;
      }
      this.requisicao.produtos.splice(index, 1);
      this.$emit('reset-fornecedor');
    },
    clearProjetoProdutos(oldProjeto) {
      this.requisicao.produtos = this.requisicao.produtos.map((produto) => {
        const produtoProjetoId = produto.projeto ? produto.projeto.id : null;
        if (oldProjeto.id === produtoProjetoId) {
          return {
            ...produto,
            projeto: null,
          };
        }
        return { ...produto };
      });
    },
    setProjetoProdutos(oldProjeto, newProjeto) {
      this.requisicao.produtos = this.requisicao.produtos.map(produto => ({
        ...produto,
        projeto: this.getProjeto(produto, oldProjeto, newProjeto),
      }));
    },
    getProjeto(produto, oldProjeto, newProjeto) {
      const oldProjetoId = oldProjeto ? oldProjeto.id : null;
      if (!produto.projeto || produto.projeto.id === oldProjetoId) {
        return newProjeto;
      }
      return produto.projeto;
    },
    clearCentroCustoProdutos(oldCentroCusto) {
      this.requisicao.produtos = this.requisicao.produtos.map((produto) => {
        const produtoCentroCustoId = produto.centroCusto ? produto.centroCusto.id : null;
        if (oldCentroCusto.id === produtoCentroCustoId) {
          return {
            ...produto,
            centroCusto: null,
          };
        }
        return { ...produto };
      });
    },
    setCentroCustoProdutos(oldCentroCusto, newCentroCusto) {
      this.requisicao.produtos = this.requisicao.produtos.map(produto => ({
        ...produto,
        centroCusto: this.getCentroCusto(produto, oldCentroCusto, newCentroCusto),
      }));
    },
    getCentroCusto(produto, oldCentroCusto, newCentroCusto) {
      const oldCentroCustoId = oldCentroCusto ? oldCentroCusto.id : null;
      if (!produto.centroCusto || produto.centroCusto.id === oldCentroCustoId) {
        return newCentroCusto;
      }
      return produto.centroCusto;
    },
    buildProdutos() {
      if (!this.requisicao.produtos || !this.requisicao.produtos.length) {
        this.requisicao.produtos = [{
          ...initalState(),
          $$id: this.idGenerator(),
        }];
        return;
      }
      this.requisicao.produtos = this.requisicao.produtos.map(produto => ({
        ...produto,
        $$id: this.idGenerator(),
      }));
    },
  },
  mounted() {
    this.buildProdutos();
  },
  watch: {
    'requisicao.projeto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearProjetoProdutos(oldValue);
        return;
      }
      this.setProjetoProdutos(oldValue, newValue);
    },
    'requisicao.centroCusto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearCentroCustoProdutos(oldValue);
        return;
      }
      this.setCentroCustoProdutos(oldValue, newValue);
    },
  },
  components: {
    pxCadastroRequisicaoProdutosTableItem: CadastroRequisicaoProdutosTableItem,
  },
};
</script>

<style scoped>
.produtos-table tr:hover:not(.v-table__expanded__content) {
  background: white !important;
}

</style>
